export const AM_APPLICATIONS_RETRIEVE_REQUESTED = 'AM_APPLICATIONS_RETRIEVE_REQUESTED';
export const AM_APPLICATIONS_RETRIEVE_SUCCEED = 'AM_APPLICATIONS_RETRIEVE_SUCCEED';
export const AM_APPLICATIONS_RETRIEVE_FAILED = 'AM_APPLICATIONS_RETRIEVE_FAILED';
